import { render, staticRenderFns } from "./LayoutNavTop.vue?vue&type=template&id=1b1b064a&scoped=true"
import script from "./LayoutNavTop.vue?vue&type=script&lang=js"
export * from "./LayoutNavTop.vue?vue&type=script&lang=js"
import style0 from "./LayoutNavTop.vue?vue&type=style&index=0&id=1b1b064a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1b064a",
  null
  
)

export default component.exports